/**
 * @fileoverview Agent definition for style-aligner-v2.
 *
 * This agent APPLIES the target style — style guide, writing-sample corpus,
 * and per-character voices — to a (typically neutral) chapter draft. It is
 * the principal voice author of the chapter: the upstream draft is a
 * structural scaffold of beats, dialogue, and action, and this agent
 * re-renders it in the target voice while preserving every beat, every
 * dialogue line's meaning, every action, POV, and scene order.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'style-aligner-v2',
  kind: 'primitive',
  name: 'Style Aligner',
  description: 'Applies the active style guide, writing-sample corpus, and per-character voices to a (typically neutral) chapter draft, producing voice-rich prose while preserving every beat, dialogue line, action, POV, and scene order.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-style-aligner-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'draft-refiner-v2',
      'pov-changer-v2',
    ],
  },
};
